import React from "react"

export default ({children}) => (
  <div style={{
    marginTop: "30px",
    textAlign: "center",
  }}>
    {children}
  </div>
)